import { Component } from '@angular/core';
import { GrocyDashboardService } from '../../../shared/services/dashboard.service';
import { GrocyActionDialogComponent } from '../action-dialog/action-dialog.component';

@Component({
  selector: 'app-grocy-stock-lookup-dialog',
  templateUrl: './stock-lookup-dialog.component.html',
  styleUrl: './stock-lookup-dialog.component.scss',
})
export class GrocyStockLookupDialogComponent extends GrocyActionDialogComponent {
  constructor(service: GrocyDashboardService) {
    super(service);
  }
}
